<template>
  <div class="d-flex justify-center align-center flex-column full-height">
    <div >
      <img :src="alreadyConfirmed" alt="error icon">
    </div>
    <p class="email-confirmation-already-confirmed">{{ $t("overview.alreadyConfirmed") }}</p>
    <p class="log-in-personal-account">{{ $t("overview.loginPersonalAccount")}}</p>
    <div @click="goToLoginPage">
      <auth-button class="email-confirmation-login">
        {{ $t("overview.Login")}}
      </auth-button>
    </div>
  </div>
</template>

<script>

import AuthButton from '@/components/auth/components/AuthButton.vue'

export default {
  name: 'EmailConfirmationStatusComponent',

  components: { AuthButton },

  data() {
    return {
      alreadyConfirmed: require('@/assets/auth/already_confirmed.svg'),
    };
  },

  methods: {
    goToLoginPage() {
      this.$router.push({ name: 'Login' })
    }
  },
};
</script>

<style scoped lang="scss">
.full-height {
  height: 100vh;
}

.email-confirmation-already-confirmed{
  color: var(--text-text-primary, #19181A);
  text-align: center;
  font-family: Roboto, sans-serif;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  margin-top: 43px;
}

.log-in-personal-account {
  color: var(--text-text-primary, #19181A);
  text-align: center;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.email-confirmation-login {
  color: var(--button-primary-button-primary-foreground-default, #FFF);
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-top: 32px;
  padding: 0 32px!important;
}
</style>
